import { render, staticRenderFns } from "./BaseLayerSwitcher.vue?vue&type=template&id=3c23274e&scoped=true"
import script from "./BaseLayerSwitcher.vue?vue&type=script&lang=js"
export * from "./BaseLayerSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BaseLayerSwitcher.vue?vue&type=style&index=0&id=3c23274e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c23274e",
  null
  
)

export default component.exports